:host {
  margin-right: var(--z-icon-right-margin, 0);
  margin-left: var(--z-icon-left-margin, 0);
  line-height: 0;
  vertical-align: middle;
}

:host svg:not([width]) {
  width: var(--z-icon-width, 1.125rem);
}

:host svg:not([height]) {
  height: var(--z-icon-height, 1.125rem);
}
